<template>
  <div>
    <section class="xs-banner service-banner contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-5 align-self-center">
            <div class="xs-banner-content">
              <ul class="breadcrumbs list-inline wow fadeInLeft" data-wow-duration="2s">
                <li><a href="https://episcloud.com">Trang chủ</a></li>
                <li>Chính sách thanh toán</li>
              </ul>
              <p class="wow fadeInUp" data-wow-duration="1.5s"></p>
            </div><!-- .xs-banner-content END -->
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="inner-welcome-image-group">
              <img src="../assets/images/who-is-bg.png" alt="Welcome banner image">
              <img src="../assets/images/search-icon.png" class="banner-ico banner-ico-1"
                   alt="banner icon"><img src="../assets/images/www.png"
                                          class="banner-ico banner-ico-2" alt="banner icon"></div>
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-30" class="full-width-content post-30 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="30" class="elementor elementor-30"
               data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-9af42a3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="9af42a3" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c5674a6"
                        data-id="c5674a6" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-e00349e elementor-widget elementor-widget-xs-heading"
                              data-id="e00349e" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Chính sách thanh toán</h3>
                                  <h2 class="heading-title">CHÍNH SÁCH <span>THANH TOÁN</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-7337b23 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="7337b23" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-8cb6da2"
                        data-id="8cb6da2" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-77c09c1 elementor-widget elementor-widget-heading"
                              data-id="77c09c1" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">THANH TOÁN TRỰC TUYẾN</h2></div>
                            </div>
                            <div
                              class="elementor-element elementor-element-8e22874 elementor-widget elementor-widget-text-editor"
                              data-id="8e22874" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>Áp dụng thanh toán với  Thẻ/Tài khoản thanh toán nội địa, quốc tế đã đăng ký thanh toán trực tuyến với Ngân hàng phát hành, phương thức thanh toán trực tuyến gồm 03 hình thức sau, gồm:</p>
                                  <ol class="order-list">
                                    <li>Thẻ thanh toán nội địa (ATM) và Tài khoản ngân hàng nội địa
                                    </li>
                                    <li>Thẻ thanh toán Quốc tế (VISA, Master, JCB, UnionPay)
                                    </li>
                                    <li>Ứng dụng Mobile Banking các Ngân hàng tại Việt Nam tích hợp thanh toán qua hình thức quét mã QRCode/ QRPay của VNPay.
                                    </li>
                                  </ol>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-920edc0 elementor-widget elementor-widget-heading"
                              data-id="920edc0" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">CHUYỂN KHOẢN</h2></div>
                            </div>
                            <div
                              class="elementor-element elementor-element-21207c5 elementor-widget elementor-widget-text-editor"
                              data-id="21207c5" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    Thanh toán qua hình thức chuyển khoản vào số tài khoản ngân hàng của EPIS Cloud Việt Nam  (Công ty TNHH EPIS Việt Nam ) theo một trong các ngân hàng sau đây:</p>
                                  <p>
                                    Thời gian EPIS Cloud Việt Nam  nhận được thanh toán phụ thuộc vào quy định chuyển khoản của các ngân hàng. <br/>
                                    Tên Ngân hàng: Ngân hàng Wooribank Việt Nam <br/>
                                    Số Tài Khoản: 902014350143 <br/>
                                    Tên Tài Khoản: PAYME EPIS VIET NAM
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-08593eb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="08593eb" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-6e33099 animated-slow animated fadeInLeft"
                        data-id="6e33099" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-eca8eaa elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="eca8eaa" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b49de96 animated-slow animated fadeInRight"
                        data-id="b49de96" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-df6f32d elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="df6f32d" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-568013b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="568013b" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-82d5282"
                        data-id="82d5282" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-7c339b6 elementor-widget elementor-widget-spacer"
                              data-id="7c339b6" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'Whois'
}
</script>

<style scoped>
.elementor-32 .elementor-element.elementor-element-5db4875 {
  padding: 80px 0px 0px 0px;
}

.elementor-32 .elementor-element.elementor-element-06cf295 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.elementor-32 .elementor-element.elementor-element-4a6e8d6 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 80px 10px 80px 10px;
}

.elementor-32 .elementor-element.elementor-element-4a6e8d6 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-32 .elementor-element.elementor-element-fbd086a .elementor-toggle-item:not(:last-child) {
  margin-bottom: 17px;
}

.elementor-32 .elementor-element.elementor-element-fbd086a .elementor-tab-title {
  background-color: #F8FAFE;
  padding: 19px 30px 19px 30px;
}

.elementor-32 .elementor-element.elementor-element-fbd086a .elementor-toggle-title, .elementor-32 .elementor-element.elementor-element-fbd086a .elementor-toggle-icon {
  color: #000000;
}

.elementor-32 .elementor-element.elementor-element-fbd086a .elementor-toggle-icon svg {
  fill: #000000;
}

.elementor-32 .elementor-element.elementor-element-fbd086a .elementor-tab-content {
  background-color: #ffffff;
  color: #70799f;
  font-family: "Karla", Sans-serif;
  letter-spacing: -0.4px;
  padding: 0px 30px 30px 30px;
}

.elementor-32 .elementor-element.elementor-element-b1b900d .elementor-toggle-item:not(:last-child) {
  margin-bottom: 17px;
}

.elementor-32 .elementor-element.elementor-element-b1b900d .elementor-tab-title {
  background-color: #F8FAFE;
  padding: 19px 30px 19px 30px;
}

.elementor-32 .elementor-element.elementor-element-b1b900d .elementor-toggle-title, .elementor-32 .elementor-element.elementor-element-b1b900d .elementor-toggle-icon {
  color: #000000;
}

.elementor-32 .elementor-element.elementor-element-b1b900d .elementor-toggle-icon svg {
  fill: #000000;
}

.elementor-32 .elementor-element.elementor-element-b1b900d .elementor-tab-content {
  background-color: #ffffff;
  color: #70799f;
  font-family: "Karla", Sans-serif;
  letter-spacing: -0.4px;
  padding: 0px 30px 30px 30px;
}

.elementor-32 .elementor-element.elementor-element-494e68a:not(.elementor-motion-effects-element-type-background), .elementor-32 .elementor-element.elementor-element-494e68a > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #f8fafe;
}

.elementor-32 .elementor-element.elementor-element-494e68a {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 80px 10px 80px 10px;
}

.elementor-32 .elementor-element.elementor-element-494e68a > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-32 .elementor-element.elementor-element-39b82ef {
  padding: 10px 10px 80px 10px;
}

.elementor-32 .elementor-element.elementor-element-5b67c38 {
  margin-top: 0px;
  margin-bottom: -200px;
}

.elementor-32 .elementor-element.elementor-element-8e30642 .xs-feature-group {
  background-color: #ffffff;
}

.elementor-32 .elementor-element.elementor-element-8e30642 .xs-feature-group .xs-title {
  color: #1e1e1e;
}

.elementor-32 .elementor-element.elementor-element-8e30642 .xs-feature-group p {
  color: #70799f;
}

.elementor-32 .elementor-element.elementor-element-8e30642 .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-32 .elementor-element.elementor-element-8e30642 {
  z-index: 2;
}

.elementor-32 .elementor-element.elementor-element-8e30642 > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-32 .elementor-element.elementor-element-008cc1a .xs-feature-group {
  background-color: #ffffff;
}

.elementor-32 .elementor-element.elementor-element-008cc1a .xs-feature-group .xs-title {
  color: #1e1e1e;
}

.elementor-32 .elementor-element.elementor-element-008cc1a .xs-feature-group p {
  color: #70799f;
}

.elementor-32 .elementor-element.elementor-element-008cc1a .btn-secondary {
  color: #ffffff;
  background-color: #1868dd;
}

.elementor-32 .elementor-element.elementor-element-008cc1a {
  z-index: 2;
}

.elementor-32 .elementor-element.elementor-element-008cc1a > .elementor-widget-container {
  box-shadow: 0px -10px 25px 0px rgba(0, 0, 0, 0.04);
}

.elementor-32 .elementor-element.elementor-element-14748a5:not(.elementor-motion-effects-element-type-background), .elementor-32 .elementor-element.elementor-element-14748a5 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-color: #113072;
}

.elementor-32 .elementor-element.elementor-element-14748a5 {
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
}

.elementor-32 .elementor-element.elementor-element-14748a5 > .elementor-background-overlay {
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}

.elementor-32 .elementor-element.elementor-element-76f9401 .elementor-spacer-inner {
  height: 80px;
}

@media (min-width: 768px) {
  .elementor-32 .elementor-element.elementor-element-1fea7b6 {
    width: 15%;
  }

  .elementor-32 .elementor-element.elementor-element-9be1d90 {
    width: 69.332%;
  }

  .elementor-32 .elementor-element.elementor-element-41a3ac1 {
    width: 15%;
  }

  .elementor-32 .elementor-element.elementor-element-f98cae5 {
    width: 15%;
  }

  .elementor-32 .elementor-element.elementor-element-b480a57 {
    width: 69.332%;
  }

  .elementor-32 .elementor-element.elementor-element-0c40af1 {
    width: 15%;
  }

  .elementor-32 .elementor-element.elementor-element-b153cbc {
    width: 15%;
  }

  .elementor-32 .elementor-element.elementor-element-37ad312 {
    width: 69.332%;
  }

  .elementor-32 .elementor-element.elementor-element-854771d {
    width: 15%;
  }

  .elementor-32 .elementor-element.elementor-element-ef21827 {
    width: 20%;
  }

  .elementor-32 .elementor-element.elementor-element-4dfc2f5 {
    width: 59.332%;
  }

  .elementor-32 .elementor-element.elementor-element-acdc1ad {
    width: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Whois.vue